import { useState, useEffect } from "react";
import BookmarkCircle from "../Icon/BookmarkCircle";

import { useSelector, useDispatch } from "react-redux";
import { addBookMark } from "../../services";
import { success, error } from "../notify";
import { setCustomerData } from "../../store/basicData/basicDataSlice";
import { setProgressData } from "../../store/progressData/progressDataSlice";
import { useProgress } from "../../hooks/useProgress";

import { setLoginModule } from "@/store/userData/userDataSlice";

const Bookmark = ({ productId, className, onLoad }) => {
  const dispatch = useDispatch();

  const loggedIn = useSelector((state) => state?.userdata?.loggedIn);
  const bookmarks = useSelector(
    (state) => state?.basicdata?.customer?.common_customer_Bookmark
  );
  const websiteColor = useSelector((state) => state?.onLoadData?.color);

  const { progressFunction } = useProgress();

  const [bookmarked, setBookmarked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [intervalData, setintervalData] = useState(null);

  // Track if bookmark was attempted before login
  const [pendingAction, setPendingAction] = useState(false);

  // ---------------------- PROGRESS BAR LOADER ----------------------
  useEffect(() => {
    if (isLoading) {
      let count = 0;
      const intervalVariable = setInterval(() => {
        if (count < 90) {
          dispatch(setProgressData(count));
        } else {
          dispatch(setProgressData(90));
          clearInterval(intervalVariable);
        }
        count += 10;
      }, 10);

      setintervalData(intervalVariable);
      progressFunction(intervalVariable);
    } else {
      dispatch(setProgressData(100));
      if (intervalData) clearInterval(intervalData);
    }
  }, [isLoading]);

  // ---------------------- UPDATE BOOKMARK STATE ----------------------
  useEffect(() => {
    if (bookmarks?.length && loggedIn) {
      const exists = bookmarks.some(
        (val) => String(val) === String(productId)
      );
      setBookmarked(exists);
    }
  }, [productId, bookmarks, loggedIn]);

  // ---------------------- API CALL ----------------------
  const handleBookmark = async () => {
    setIsLoading(true);
    const { status, data } = await addBookMark(productId);

    if (status === 200) {
      if (data.status === "success") {
        setIsLoading(false);
        dispatch(setCustomerData(data.customer));
        success(data.msg, true);
        onLoad();
      } else {
        setIsLoading(false);
        error("Something went wrong!! Please try again", true);
      }
    }
  };

  // ---------------------- CLICK HANDLER ----------------------
  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!loggedIn) {
      setPendingAction(true);
      dispatch(setLoginModule(true)); // OPEN LOGIN MODAL
      return;
    }

    handleBookmark();
  };

  // ---------------------- RETRY ACTION AFTER LOGIN ----------------------
  useEffect(() => {
    if (loggedIn && pendingAction) {
      setPendingAction(false);
      handleBookmark();
    }
  }, [loggedIn]);

  return (
    <div
      onClick={onClick}
      className="absolute rounded-full flex justify-center right-2.5 top-2.5 items-center shadow-md 
                h-6 w-6 bg-white md:h-8 md:w-8"
    >
      <BookmarkCircle
        className={`z-20 flex ${className} ${bookmarked ? "stroke-white" : ""
          } cursor-pointer`}
        bookmark={bookmarked}
        style={{
          color: websiteColor,
          fill: bookmarked ? websiteColor : "",
        }}
      />
    </div>
  );
};

export default Bookmark;
